import palsReducer from './pals.slice';

export * from './pals.slice';
export * from './pals.thunk';

export default palsReducer;
